import { DEFAULT_IMAGE_TYPE } from "@config/config";

export const parseDataURLtoFile = async (dataurl: string, fileName?: string, fileType?: string) => {
  return await fetch(dataurl)
    .then((res) => res.blob())
    .then((blob) => new File([blob], fileName || "File name", { type: fileType || DEFAULT_IMAGE_TYPE }));
};
